import { forwardRef, type ComponentProps, type ReactNode } from 'react';
import { Dica } from '@/componentes/Dica';
import { Button } from '@/componentes/ui/button';
import { cn } from '@/lib/utils';

type Props = Omit<ComponentProps<typeof Button>, 'children'> & {
  /** O nome do botão: vai para `aria-label` e `sr-only`. */
  rotulo: string;
  icone: ReactNode;
  /** O texto do tooltip, quando precisa dizer mais que o rótulo. Sem ele, o tooltip mostra o rótulo. */
  dica?: string;
  /** Motivo de estar desabilitado; também desabilita o botão (ver `Dica`). */
  desabilitadoPor?: string | null;
};

/**
 * Botão só de ícone, com os três rótulos que a CONVENCOES-UI §8 exige: `aria-label`, `sr-only` e `Tooltip`.
 * Encaminha a ref e as props para servir de gatilho de diálogo e de menu (`asChild`).
 */
export const BotaoIcone = forwardRef<HTMLButtonElement, Props>(function BotaoIcone(
  { rotulo, icone, dica, desabilitadoPor, disabled, className, ...resto },
  ref,
) {
  return (
    <Dica texto={dica ?? rotulo} desabilitadoPor={desabilitadoPor}>
      <Button
        ref={ref}
        type="button"
        variant="ghost"
        size="icon"
        className={cn('size-11', className)}
        aria-label={rotulo}
        disabled={disabled === true || Boolean(desabilitadoPor)}
        {...resto}
      >
        {icone}
        <span className="sr-only">{rotulo}</span>
      </Button>
    </Dica>
  );
});
